import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";

const { Option } = Select;

const NOMBRES_DOCUMENTO = {
  Cotizacion: "Cotización",
  Pedido: "Pedido",
  Venta: "Venta / Remisión",
  Requisicion: "Requisición",
  OrdenDeCompra: "Orden de Compra",
  Factura: "Factura",
};
class SelectDocumentoItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
    };
    this.buscarDocumentos = debounce(this.buscarDocumentos.bind(this), 300);
  }

  componentDidMount() {
    if (this.props.tipo && this.props.tipo !== "Ninguno") {
      this.buscarDocumentos("");
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tipo !== this.props.tipo) {
      this.setState({ opciones: [] }, () => this.buscarDocumentos(""));
    }
  }

  async buscarDocumentos(query) {
    const { tipo, headersToken } = this.props;
    if (!tipo || tipo === "Ninguno") return;

    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "transiciones/selectDocumentoItem",
        { tipo, query, empresaId: this.props.empresaId },
        { headers: headersToken },
      );

      if (res.data.success === 2) {
        this.setState({ opciones: res.data.documentos });
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      console.error("Error al buscar documentos:", error);
      this.setState({ opciones: [] });
    } finally {
      this.setState({ cargando: false });
    }
  }

  render() {
    const { tipo, headersToken, style, placeholder, ...restProps } = this.props;
    const { opciones, cargando } = this.state;

    return (
      <Select
        showSearch
        filterOption={false}
        onSearch={this.buscarDocumentos}
        loading={cargando}
        placeholder={placeholder || `Buscar ${NOMBRES_DOCUMENTO[tipo] || tipo}...`}

        notFoundContent={cargando ? <Spin size="small" /> : "Sin resultados"}
        dropdownRender={(menu) => <Spin spinning={cargando}>{menu}</Spin>}
        style={{ width: "100%", ...style }}
        bordered={false}
        {...restProps}
        onChange={(value) => {
          const doc = opciones.find((d) => d._id === value);
          this.props.onChange?.(value, doc);
        }}
      >
        {opciones.map((doc) => (
          <Option key={doc._id} value={doc._id}>
            {doc.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}
export { NOMBRES_DOCUMENTO };

export default SelectDocumentoItem;
